export default __webpack_public_path__ + "static/media/MendocinoMap.9bf24b14.jpg";